import { render } from "./modal-overlay.vue?vue&type=template&id=0da325b8"
import script from "./modal-overlay.vue?vue&type=script&lang=js"
export * from "./modal-overlay.vue?vue&type=script&lang=js"

const cssModules = {}
import style0 from "./modal-overlay.vue?vue&type=style&index=0&id=0da325b8&lang=scss&module=true"
cssModules["$style"] = style0

import exportComponent from "/home/r/Desktop/ev-switch-global/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__cssModules',cssModules]])

export default __exports__